import React from 'react';
import c from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import s from './PopoverRootLayout.scss';
/** Our standard Popover layout, included at the root of the content. */ const PopoverRootLayout = ({ header , preamble , content , footer , className , contentClassName , showHeaderBorder , showFooterBorder  })=>/*#__PURE__*/ React.createElement(Section, {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: c(s['header-and-preamble-wrapper'], showHeaderBorder && s['border'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['header-wrapper']
    }, header), // No need for a wrapper, the spec doesn't have defined paddings for this guy.
    // We'll rely on the consumer to lay this out right.
    preamble), /*#__PURE__*/ React.createElement("div", {
        className: c(s['content-wrapper'], !footer && s['no-footer'], contentClassName)
    }, content), footer && /*#__PURE__*/ React.createElement("div", {
        className: c(s['footer-wrapper'], showFooterBorder && s['border'])
    }, footer));
PopoverRootLayout.displayName = 'PopoverRootLayout';
export default PopoverRootLayout;
